module.exports = __webpack_public_path__ + "img/renew.a9b821f9.svg";